<template>
  <b-modal
    :visible="visible"
    no-close-on-backdrop
    size="sm"
    :title="$t('Registration')"
    title-class="font-18"
    hide-footer
    @hidden="$emit('close')"
  >
    <p class="font-weight-bold mb-1">
      {{ $t('Choose Maintenance Plan to add Asset') }}
    </p>
    <b-form-group :label="$t('Maintenance Plan')">
      <v-select
        :value="selectedPlanId"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="options"
        :reduce="val => val.value"
        :placeholder="$t('Select a plan')"
        @input="$emit('update:selectedPlanId', $event)"
      />
    </b-form-group>
    <p v-if="options.length === 0" class="text-muted small">
      {{ $t('No matching records found') }}
    </p>
    <div class="text-right">
      <b-button variant="outline-secondary" class="mr-50" @click="$emit('close')">
        {{ $t('Cancel') }}
      </b-button>
      <b-button variant="primary" :disabled="!selectedPlanId || binding" @click="$emit('bind')">
        <b-spinner v-if="binding" small class="mr-25" />
        {{ $t('Add') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BButton, BFormGroup, BModal, BSpinner } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'BindPlanModal',
  components: {
    BButton, BFormGroup, BModal, BSpinner, vSelect,
  },
  props: {
    visible: { type: Boolean, default: false },
    selectedPlanId: { default: null },
    options: { type: Array, default: () => [] },
    binding: { type: Boolean, default: false },
  },
}
</script>
